import { render, staticRenderFns } from "./ntdetails.vue?vue&type=template&id=f00c2976&scoped=true"
import script from "./ntdetails.vue?vue&type=script&lang=js"
export * from "./ntdetails.vue?vue&type=script&lang=js"
import style0 from "./ntdetails.vue?vue&type=style&index=0&id=f00c2976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00c2976",
  null
  
)

export default component.exports